import {Pipe, PipeTransform} from "@angular/core";
import {ExternalNumberType} from "../../model/externalNumberType";

@Pipe({name: 'numberType'})
export class NumberType implements PipeTransform {
    transform(value: any) {
        return ExternalNumberType[value];
    }
}
